module.exports = __webpack_public_path__ + "static/media/ilha_1.3900b3dc.jpg";